import React from 'react';

import { FilterColumnCardStyle, FilterColumnCardWrapperStyle } from '../style';

import { functionsArray } from '../../../../../../consts/functions';
import { listOperators, operatorsArray } from '../../../../../../consts/operators';

import ConditionalInput from './ConditionalInput';
import classNames from 'classnames';
import MultipleValues from '../../../../../../components/MultipleValues';
import { IoIosArrowDown } from 'react-icons/io';
import { MdDragIndicator } from 'react-icons/md';
import { Checkbox, rem, Select } from '@mantine/core';

const FilterColumnCard = ({
  id,
  func,
  value,
  column,
  columns,
  operator,
  onSelect,
  inputType,
  isSelected,
  hideFunction,
  onChangeInput,
  onAddListItem,
  onChangeColumn,
  dragHandleProps,
  onRemoveListItem,
  onChangeFunction,
  onChangeOperator,
  onChangeInputType,
  errors,
  onChangeSelectedColumns,
  hiddenVariants,
  showDate = true
}) => {
  const rootId = id || 'grid-table-filter-card';
  const isOperatorListType = listOperators.includes(operator);

  return (
    <FilterColumnCardWrapperStyle id={id ? `${rootId}-root` : 'grid-table-filter-card-root'}>
      <div
        id={id ? `${rootId}-drag` : 'grid-table-filter-card-drag'}
        {...dragHandleProps}
        className="drag-handle"
      >
        <MdDragIndicator color="#C1C2C5" width="20px" height="20px" />
      </div>

      <div
        id={id ? `${rootId}-checkbox` : 'grid-table-filter-card-checkbox'}
        className="checkbox_line"
      >
        <Checkbox
          id={id ? `${rootId}-checkbox-input` : undefined}
          checked={isSelected}
          onClick={onSelect}
          size={rem(16)}
        />
      </div>

      <FilterColumnCardStyle id={id ? `${rootId}-content` : 'grid-table-filter-card-content'}>
        <div
          id={id ? `${rootId}-columns` : 'grid-table-filter-card-columns'}
          className="filter-columns"
        >
          <div
            className={classNames('filter-elements', {
              noFunction: hideFunction
            })}
          >
            {!hideFunction && (
              <div
                id={id ? `${rootId}-function` : 'grid-table-filter-card-function'}
                className="form-element"
              >
                <Select
                  id={id ? `${rootId}-function-select` : undefined}
                  placeholder="Choose"
                  data={functionsArray}
                  value={func}
                  size="xs"
                  searchable
                  clearable
                  onChange={onChangeFunction}
                  rightSection={<IoIosArrowDown />}
                  rightSectionPointerEvents="none"
                  label="Function"
                  required
                  w="100%"
                  error={errors?.includes('function')}
                />
              </div>
            )}

            <div
              id={id ? `${rootId}-column` : 'grid-table-filter-card-column'}
              className="form-element"
            >
              <Select
                id={id ? `${rootId}-column-select` : undefined}
                placeholder="Choose"
                data={columns}
                value={column}
                size="xs"
                searchable
                clearable
                onChange={onChangeColumn}
                rightSection={<IoIosArrowDown />}
                rightSectionPointerEvents="none"
                label="Column"
                required
                w="100%"
                error={errors?.includes('column')}
              />
            </div>

            <div
              id={id ? `${rootId}-operator` : 'grid-table-filter-card-operator'}
              className="form-element"
            >
              <Select
                id={id ? `${rootId}-operator-select` : undefined}
                placeholder="Choose"
                data={operatorsArray}
                value={operator}
                size="xs"
                searchable
                clearable
                onChange={onChangeOperator}
                rightSection={<IoIosArrowDown />}
                rightSectionPointerEvents="none"
                label="Operator"
                required
                w="100%"
                error={errors?.includes('operator')}
              />
            </div>

            {isOperatorListType ? (
              <MultipleValues
                isRequired
                values={value?.list}
                onAddValue={onAddListItem}
                onRemoveValue={onRemoveListItem}
              />
            ) : (
              <ConditionalInput
                value={value?.[inputType]}
                type={inputType}
                required={true}
                hasRequiredError={errors?.includes('value')}
                onChangeType={val => onChangeInputType(val)}
                onChangeValue={val => onChangeInput(val)}
                columns={columns}
                hiddenVariants={hiddenVariants}
                showDate={showDate}
                onChangeSelectedColumns={onChangeSelectedColumns}
              />
            )}
          </div>
        </div>
      </FilterColumnCardStyle>
    </FilterColumnCardWrapperStyle>
  );
};

export default FilterColumnCard;
